import { pluralize } from 'common/utils/utils';
import Text from 'components/base/Text';
import { Padding } from 'components/base/layout-components';

const FormItemTitle = ({ title, data = [] }) => {
  return (
    <Padding b='smaller'>
      <Text size='smaller' textTransform='uppercase' color='shuttleGray'>
        {title}
        {data.length > 0 && ` (${pluralize(data.length, 'team')} selected)`}
      </Text>
    </Padding>
  );
};

export default FormItemTitle;
